// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router/index'
import {utils} from './utils.js'
import VueCookies from 'vue-cookies';
import Vuex from 'vuex'
import axios from 'axios'
import i18n from './i18n'

// import createPersistedState from 'vuex-persistedstate'

Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.use(VueCookies)
Vue.prototype.$utils = utils


const store = new Vuex.Store({
  /*
  plugins: [createPersistedState({
      storage: window.sessionStorage,
  })],
  */
  state: {
    ws_type: 2, // 1=PHP, 2=Java
    ws_url: '',
    rastrea_url: '',

    menu: [
      /*
      {
          name: 'Dashboard Financeiro',
          url: '/dashboard-finance',
          icon: 'icon-speedometer',
        },
      */
        {
          name: 'Portal',
          url: '/dashboard',
          icon: 'icon-speedometer',
        },
      ]
    ,
    currentUser: {
    },
    currentUnit: {
    },

    theme: localStorage.getItem('smg_theme') || 'light',

    // Populado em tempo de execução a partir de public/config.json (ver bootstrap() abaixo)
    config: {}
  },
  mutations: {
    SET_MENU(state, usermenu) {
      state.menu = usermenu;
    },
    SET_CURRENT_USER(state, user) {
      state.currentUser = user;
    },
    SET_CURRENT_UNIT(state, unit) {
      state.currentUnit = unit;
    },
    SET_WS_URL(state, ws_url) {
      state.ws_url = ws_url;
    },
    SET_THEME(state, theme) {
      state.theme = theme;
      localStorage.setItem('smg_theme', theme);
    },
    SET_CONFIG(state, config) {
      state.ws_url = config.ws_url;
      state.rastrea_url = config.rastrea_url;
      state.config = config;
    },
  },
  actions: {},
  getters: {
    currentLogo(state) {
      const config = state.config || {};
      if (state.theme === 'dark') return config.logoDark || config.logo;
      if (state.theme === 'shockwave') return config.logoShockwave || config.logo;
      return config.logo;
    }
  }
});

// Qualquer resposta de erro do backend indicando sessão inválida/sem permissão
// (userAccessService.checkAccess retornando false) devolve a mesma mensagem
// "message.access.error", em pt-BR ou en-US dependendo do locale resolvido.
const ACCESS_DENIED_MESSAGES = ['sem permissão de acesso', 'no access permission', 'sin permiso de acceso']

axios.interceptors.response.use(
  response => response,
  error => {
    const message = error.response && error.response.data && error.response.data.message
    if (message && ACCESS_DENIED_MESSAGES.some(known => message.toLowerCase().includes(known))) {
      store.commit('SET_CURRENT_USER', {})
      store.commit('SET_CURRENT_UNIT', {})

      const storageName = store.state.config.storageName
      if (storageName) {
        localStorage.setItem(storageName + '_USER', null)
        localStorage.setItem(storageName + '_MENU', null)
      }

      if (router.currentRoute.path !== '/pages/login') {
        router.push({ path: '/pages/login' }).catch(() => {})
      }
    }
    return Promise.reject(error)
  }
)

async function bootstrap() {
  try {
    const response = await fetch(process.env.BASE_URL + 'config.json', { cache: 'no-store' })
    const config = await response.json()
    store.commit('SET_CONFIG', config)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Não foi possível carregar public/config.json', error)
  }

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {
      App
    },
    store: store,
    i18n,
  })
}

bootstrap()
